import { Select as AntdSelect, SelectProps } from "antd";
import FormItem from "@components/FormItem";

type Props<T> = {
  selectProps?: SelectProps<T>;
  label?: string;
  hint?: string;
};

export default function MultiSelect({
  label = "",
  hint = "",
  selectProps = {},
}: Props<string[]>) {
  return (
    <FormItem label={label} hint={hint}>
      <AntdSelect mode="multiple" style={{ width: "100%" }} {...selectProps} />
    </FormItem>
  );
}
